var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReports = function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    stroke: "#8799AE",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8799AE",
    d: "M17.828 6.828c.579.578.867.868 1.02 1.235.152.368.152.776.152 1.594V17c0 1.886 0 2.828-.586 3.414S16.886 21 15 21H9c-1.886 0-2.828 0-3.414-.586S5 18.886 5 17V7c0-1.886 0-2.828.586-3.414S7.114 3 9 3h3.343c.818 0 1.226 0 1.594.152s.657.442 1.235 1.02z",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.828 6.828c.579.578.867.868 1.02 1.235.152.368.152.776.152 1.594V17c0 1.886 0 2.828-.586 3.414S16.886 21 15 21H9c-1.886 0-2.828 0-3.414-.586S5 18.886 5 17V7c0-1.886 0-2.828.586-3.414S7.114 3 9 3h3.343c.818 0 1.226 0 1.594.152s.657.442 1.235 1.02z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 11v6M12 12v5M9 14v3"
  })));
};
export default SvgReports;